import { render } from "./UserHeaderComponent.vue?vue&type=template&id=a85e4728&scoped=true"
import script from "./UserHeaderComponent.vue?vue&type=script&lang=js"
export * from "./UserHeaderComponent.vue?vue&type=script&lang=js"

import "./UserHeaderComponent.vue?vue&type=style&index=0&id=a85e4728&lang=scss&scoped=true"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a85e4728"]])

export default __exports__